import { baseApi, type MoneyDto } from '@shared/api/baseApi';

export interface UserDto {
  id: string;
  telegramId: string | null;
  firstName: string | null;
  username: string | null;
  balance: MoneyDto;
  createdAt: string;
  /** Cosmetic only — the server re-checks on every admin route. */
  isAdmin: boolean;
  /** Private capability granted by an administrator. */
  isReseller: boolean;
  resellerStatus: 'ACTIVE' | 'SUSPENDED' | null;
}

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<UserDto, void>({
      query: () => '/me',
      transformResponse: (response: { user: UserDto }) => response.user,
      providesTags: ['User'],
    }),
    heartbeatPresence: builder.mutation<{ seenAt: string }, void>({
      query: () => ({ url: '/presence', method: 'POST' }),
    }),
  }),
});

export const { useGetMeQuery, useHeartbeatPresenceMutation } = userApi;
